<template>
  <el-dialog
    :close-on-click-modal="false"
    title="选择产品99"
    :visible.sync="visible"
    width="1200px"
    :before-close="handleClose"
  >
    <div
      id="productDialog"
      style="overflow: hidden; height: 60vh; overflow: auto"
    >
      <div class="left">
        <Menu @select="handleSelectMenu"></Menu>
      </div>
      <div class="right">
        <div class="tab-body" style="margin-top: 0">
          <el-input
            v-model="form.proName"
            placeholder="搜索产品名称/编号"
            size="small"
            suffix-icon="el-icon-search"
            style="width: 300px; float: left"
            @change="getData"
          ></el-input>
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
            :pageCount="5"
          />
          <div class="product-list">
            <template v-for="(item, index) in tableData">
              <div class="pro-card">
                <div
                   @mouseover="handleMouseOver(item)"
                  @mouseout="handleMouseOut(item)"
                 @click="handleChecked(item)" class="card-img">
                  <!-- item.thumb -->
                  <img
                    :style="{ height: '181' + 'px' }"
                    style="width: 100%"
                    :src="
                      item.mainList.length > 0
                        ? `${
                            item.mainList[item.currentProduct].picUrl
                          }?x-oss-process=image/resize,m_fill,h_500,w_500`
                        : ''
                    "
                    lazy
                  />
                </div>
                <div
                  :style="{
                    width: imageWidth + 'px',
                    top: imageWidth - 36 + 'px',
                  }"
                  :class="`sku-img-list tp-${index}`"
                >
                  <div class="img-content">
                    <ul>
                      <li
                        :class="{ 'is-select': item.currentProduct === number }"
                        @mouseover="handleSelectSku(item, number)"
                        v-for="(record, number) in item.mainList"
                        :key="number"
                        :style="{
                          backgroundColor: dictMap['color'][record.skuName],
                        }"
                      ></li>
                    </ul>
                  </div>
                </div>

                <div class="card-info">
                  <div class="info-div" v-show="item.showTitle">
                    <div class="detail">
                      <div class="text">
                        <span class="price">
                          <span class="unit">￥</span
                          >{{ item.mainList[item.currentProduct].price }}</span
                        ><span class="date">{{ item.prodDays }}天</span>
                      </div>
                      <div :title="item.proName" class="product-title">
                        {{ item.proName }}
                      </div>
                      <div class="product-tag">
                        <div style="float: left">
                          {{
                            dictMap["product_type"]
                              ? dictMap["product_type"][item.productType]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="factory text">
                        生产商：{{ item.manufacturer }}
                      </div>
                    </div>
                  </div>
                  <div class="btn-div" v-show="!item.showTitle">
                    <div class="pa c153 price-gradient-box">
                      <div class="relative">
                        <div
                          class="flex-row flex-x-full weight-box"
                          style="margin-bottom: 8px"
                        >
                          <div class="w50">{{ item.weight }}</div>
                          <div class="w50">{{ item.pdMaterial }}</div>
                        </div>
                        <div class="pl10 mt15">
                          80%平均时效：<span class="red">{{
                            item.mostDelivery
                          }}</span>
                        </div>
                        <div class="pl10 mt5">
                          平均发货时效：<span class="red">{{
                            item.avgDelivery
                          }}</span>
                        </div>
                        <div class="pl10 mt5 pb10">
                          生产商承诺发货：<span class="red">{{
                            item.agreeDelivery
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="checkbox">
                  <el-checkbox v-model="item.checked"></el-checkbox>
                </div>
              </div>
            </template>
          </div>
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
            :pageCount="5"
          />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getProductList } from "@/api/customProduct/product"
import { mapGetters } from "vuex"
import Menu from "./Menu"

let timer = null

export default {
  components: { Menu },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "change",
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getData()
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 30,
        proName: "",
        productType: '01',
        features: '01,03'
      },
      productList: [],
      tableData: [],
      total: 0,
      loading: false,
      imageWidth: "",
      imageHeight: "",
    }
  },

  methods: {
    getData() {
      this.loading = true
      this.startLoading()
      getProductList(this.form)
        .then((res) => {
          for (let record of res.rows) {
            record.showTitle = true
            record.currentProduct = 0
            record.checked = false
            for (let image of record.mainList) {
              if (image.isMain == "2") {
                for (let picture of record.mainList) {
                  if (picture.isMain == "1") {
                    picture.picUrlOther = image.picUrl
                    picture.picUrlBak = picture.picUrl
                    break
                  }
                }
                break
              }
            }
            for (let i = 0; i < record.mainList.length; i++) {
              if (record.mainList[i].isMain == "2") {
                record.mainList.splice(i, 1)
                i--
              }
            }
          }
          this.tableData = res.rows
          this.total = res.total
          this.loading = false

          this.$nextTick(() => {
            document.querySelector("#productDialog").scrollTop = 0
          })

          this.$nextTick(() => {
            let cardImg = document.querySelector(".card-img")
            if (cardImg) {
              let height = cardImg.offsetWidth
              this.imageWidth = cardImg.offsetWidth
              this.imageHeight = height
            }
          })
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleChecked(item) {
      item.checked = !item.checked
    },
    handleSelectSku(item, number) {
      item.currentProduct = number
    },
    handleClose() {
      this.$emit("change", false)
    },
    handleConfirm() {
      let array = this.tableData.filter((item) => {
        return item.checked
      })

      this.$emit("select", array)
      this.$emit("change", false)
    },
    handleSelectMenu(data) {
      this.form.typeId = data.typeId
      this.getData()
    },
     handleMouseOver(item) {
      if (item.mainList[item.currentProduct].picUrlOther) {
        item.mainList[item.currentProduct].picUrl =
          item.mainList[item.currentProduct].picUrlOther
      }
      item.showTitle = false
    },
    handleMouseOut(item) {
      if (item.mainList[item.currentProduct].picUrlOther) {
        item.mainList[item.currentProduct].picUrl =
          item.mainList[item.currentProduct].picUrlBak
      }
      item.currentProduct = 0
      item.showTitle = true
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.product-list {
  position: relative;
}
.productPanInfo,
.imgPanInfo {
  position: absolute;
  width: 240px;
  left: 338px;
  top: -57px;
  background: rgba(246, 246, 246, 0.95);
  box-shadow: 0px 0px 8px 0px rgba(153, 153, 153, 1);
  border-radius: 2px;
  padding: 10px 10px;
  color: rgb(77, 77, 77);
  overflow: hidden;
  z-index: 99;
  line-height: 24px;
  .imgPanInfoName {
  }
  .imgPanInfoStandard {
    font-size: 12px;
    color: #aaaaaa;
  }
  .color-picker-list {
    overflow: hidden;
    margin-left: -4px;
  }
  .color-picker-list li,
  .color-picker-list-hover li,
  .mgg-preview-colors li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }

  .color-picker-list li.cur,
  .mgg-preview-colors li.cur {
    border: rgb(236, 78, 43) solid 2px;
  }

  .color-picker-list li a,
  .color-picker-list-hover li a,
  .mgg-preview-colors li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.left {
  float: left;
  width: 225px;
}
.right {
  float: left;
  width: 927px;
}
#custom-online .tab-body {
  ::v-deep .el-form-item__content {
    line-height: 50px;
  }
  .product-list {
    overflow: hidden;
    ::v-deep .pro-card:first-child {
    }
    ::v-deep .pro-card:last-child {
    }

    .pro-card {
      width: calc(25% - 17px);
      float: left;
      box-sizing: border-box;
      margin: 4px 12px 12px 4px;
      padding: 16px 16px 6px 16px;
      background: #ffffff;
      border: 1px solid rgb(221, 221, 221);
      position: relative;
      .detail {
        line-height: 30px;
      }
      .unit {
        font-size: 12px;
      }
      .card-img {
        cursor: pointer;
      }
      .image {
        padding: 16px;
        cursor: pointer;
      }
      .text {
        overflow: hidden;
        font-size: 14px;
      }
      .product-title {
        font-size: 14px;
        box-sizing: border-box;
        padding-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .product-tag {
        line-height: 14px;
        margin: 0 0 10px 0;
        overflow: hidden;
        .left {
          display: inline-block;
          font-size: 12px;
          padding: 2px 6px;
          background: #409eff;
          border-radius: 5px;
          color: #ffffff;
        }
      }
      .factory {
        border-top: 1px solid #ebeef5;
      }
      .price {
        float: left;
        color: #409eff;
        font-size: 18px;
        font-weight: bold;
      }
      .date {
        float: right;
      }
    }
    .pro-card:hover {
      cursor: auto;
      color: #000 !important;
      box-shadow: 0 0px 6px 0 #409eff;
      transition: all 0.35s;
    }
  }
}
.form-body {
  margin-right: 8px;
  padding-bottom: 6px;
  padding: 10px 0;
}
.form {
  padding: 0 16px;
}

.sku-img-list {
  clear: both;
  width: 223px;
}
.sku-img-list .prev {
  float: left;
  margin-right: 2px;
}
.sku-img-list .next {
  float: right;
}
.sku-img-list .prev,
.tab-body .pro-card .pro-content .sku-img-list .next {
  display: block;
  font-family: "宋体";
  text-align: center;
  width: 10px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-decoration: none;
}
.sku-img-list .img-content {
  position: relative;
  height: 53px;
  overflow: hidden;
}
.sku-img-list ul {
  position: absolute;
  width: 99999px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  list-style-type: none;
}
.sku-img-list ul li {
  float: left;
  width: 25px;
  height: 25px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ebeef5;
  margin-right: 4px;
}
.sku-img-list ul li img {
  width: 25px;
  height: 25px;
}
.sku-img-list ul li img:hover {
}
.price-gradient-box {
  overflow: hidden;
  width: 100%;
  background: #fff;
  z-index: 100;
  transform: translateZ(1000px);
  font-size: 12px;
}
.price-gradient-box .weight-box {
  height: 42px;
  line-height: 42px;
  border: 1px solid #ededed;
  text-align: center;
}
.price-gradient-box .weight-box div:not(:first-child) {
  border-left: 1px solid #ededed;
}
.price-gradient-box > div {
  background: #fff;
}
.price-gradient-box:hover,
.com-pt-img:hover ~ .price-gradient-box {
  bottom: 5px;
  left: 0;
  overflow: hidden;
  z-index: 100;
  transform: translateZ(1000px);
}
.price-gradient-box .swiper-slide {
  text-align: center;
  border: 1px solid #ededed;
  padding: 10px 0;
}
.price-gradient-box .swiper-slide + .swiper-slide {
  border-left: none;
}
.product-swiper-box .next-btn,
.product-swiper-box .per-btn,
.price-gradient-box .next-btn,
.price-gradient-box .per-btn {
  z-index: 2;
  top: 60px;
  padding: 5px;
  width: 20px;
  height: 20px;
  line-height: 0px;
  background: rgba(235, 246, 255, 0.5);
  text-align: center;
}
.w50 {
  width: 50% !important;
}
.flex-x-full {
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flex-row {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}
.red {
  color: #ff4d3a !important;
}
.c153 {
  color: rgb(153, 153, 153);
}
.filter {
  background: #ffffff;
  border-top: 1px solid rgb(221, 221, 221);
  margin: 4px 0 0 0;
  overflow: hidden;
  padding: 12px 16px 0 16px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.is-select {
  border: 1px solid #333333 !important;
}
#custom-online .tab-body .card-img:hover {
  // .card-info .info-div {
  //   opacity: 0;
  // }
  // .card-info .btn-div {
  //   opacity: 1;
  // }
}
#custom-online .tab-body .pro-card .card-info {
  height: 122px;
}
.checkbox {
  position: absolute;
  right: 21px;
  top: 16px;
}
</style>
